// extracted by mini-css-extract-plugin
export default {"news-content":"NewsBullets_news-content__DVNxL","img-div":"NewsBullets_img-div__vz8ue"};